<script>
	export let id;
	export let taskDescription;
	export let taskProject;
	export let taskPhase;
	export let taskTask;
	export let timeStart; 	// 00:00
	export let timeEnd;
	//export let total;
	import { createEventDispatcher } from "svelte";

	// EDIT -- COMPROBAR QUE NO MODIFICO REGISTRO DE OTRO DIA

	import { formatTime, timeToMs, msToTime } from "../js/formatDateTime";
    
	const dispatch = createEventDispatcher();

	function dispatchBtnDelete(id) {
		dispatch("dispatchDelete", {
			id: id
		});
	}
	function dispatchBtnCopy(id) {
		dispatch("dispatchCopy", {
			id: id
		});
	}
	function dispatchBtnModify() {
		let today = new Date();
		let startSplit = timeStart.split(":");
		let endSplit = timeEnd.split(":");
		let newStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(startSplit[0]),  parseInt(startSplit[1]));
		let newEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(endSplit[0]),  parseInt(endSplit[1]));

		dispatch("dispatchModify", {
			id: id,
			desc: taskDescription,
			start: newStart.getTime(),
			end: newEnd.getTime(),
			startTime: timeStart,
			endTime: timeEnd,
			total: total
		});
	}
	let total = "";

	function getTotalTime(millisStart, millisEnd, type = "substract") {
		if(type === "substract") {
			if(millisStart < millisEnd) {
				return msToTime(millisEnd - millisStart);
			} else {
				return "?";
			}
		} else if(type === "add") {
			return msToTime(millisStart + millisEnd);
		}
	}

	function autoCompleteTime(action = "setTotal") {
		timeStart = formatTime(timeStart);
		timeEnd = formatTime(timeEnd);
		total = formatTime(total);
		if (timeStart !== "?" && (timeEnd !== "?" || total !== "?")) {
			let time1 = timeStart;
			time1 = timeToMs(time1);
			if(action === "setTotal") {
				let time2 = timeEnd;
				time2 = timeToMs(time2);
				total = getTotalTime(time1, time2, "substract");
			} else if(action === "setEnd") {
				let time2 = total;
				time2 = timeToMs(time2);
				timeEnd = getTotalTime(time1, time2, "add");
			}
		}
	}

	autoCompleteTime();
	//on:blur={() => dispatchBtnModify(id, taskDescription, timeStart, timeEnd)}
</script>

<!-- ################################       AÑADIRLE A LOS IDS UNA VARIABLE PARA QUE SEAN UNICOS        ############################## -->

<div class="container flex w-100">
	<div class="description h-100 padding align-center">
		<input
			class="w-100"
			type="text"
			name="description"
			id="description"
			bind:value={taskDescription}
			on:blur={() => (dispatchBtnModify())}
		/>
	</div>
	<div class="project h-100 padding align-center">
		<span class="w-100">{taskProject}</span>
		<!--
		<input
			class="w-100"
			type="text"
			name="project"
			id="project"
			value={taskProject}
		/>
		-->
	</div>
	<div class="project h-100 padding align-center">
		<span class="w-100">{taskPhase}</span>
		<!--
		<input
			class="w-100"
			type="text"
			name="project"
			id="project"
			value={taskProject}
		/>
		-->
	</div>
	<div class="task h-100 padding align-center">
		<span class="w-100">{taskTask}</span>
		<!--
		<input
			class="w-100"
			type="text"
			name="task"
			id="task"
			value={taskTask}
		/>
		-->
	</div>
	<div class="billable flex h-100 padding align-center">
		{#if taskPhase === "Time Off"}
			<img class="icon" src="/images/euro.svg" alt="No billable" />
		{:else}
			<img class="icon" src="/images/euro_azul.svg" alt="Billable" />
		{/if}
	</div>
	<div class="time_container h-100 padding flex align-center">
		<img class="icon" src="/images/chrono.svg" alt="chrono" />

		<input
			type="text"
			name="time_start"
			id="time_start"
			bind:value={timeStart}
			on:blur={() => (autoCompleteTime())}
			on:blur={() => (dispatchBtnModify())}
		/>
		<span class="padding">to</span>
		<input
			type="text"
			name="time_end"
			id="time_end"
			bind:value={timeEnd}
			on:blur={() => (autoCompleteTime())}
			on:blur={() => (dispatchBtnModify())}
		/>
	</div>
	<div class="time_total h-100 padding align-center">
		<input
			type="text"
			name="total"
			id="total"
			bind:value={total}
			on:blur={() => (autoCompleteTime("setEnd"))}
			on:blur={() => (dispatchBtnModify())}
		/><span>h</span>
	</div>
	<div class="buttons flex align-center">
		<img class="icon pointer" src="/images/copy.svg" alt="copy" on:click={() => dispatchBtnCopy(id)}/>
		<img class="icon pointer" src="/images/x.svg" alt="remove" on:click={() => dispatchBtnDelete(id)}/>
	</div>
</div>

<style>

	.align-center {
		align-items: center !important;
		display: flex;
	}

	.pointer {
        cursor: pointer;
	}
	.container {
		height: 30px;
		border-radius: 40px;
	}
	.flex {
		align-items: center;
		justify-content: space-between;
		display: flex;
	}

	.w-100 {
		width: 100% !important;
	}

	.description {
		flex-grow: 7;
		max-width: 250px;
	}

	.project,
	.task {
		flex-grow: 3;
		max-width: 250px;
	}

	.padding {
		padding: 0 10px 0 10px;
	}

	.h-100 {
		height: 100% !important;
	}

	.icon {
		width: 16px;
		margin: 0 5px 0 5px;
	}

	.time_total {
		margin: 0 10px 0 10px;
	}

	.time_total input,
	.time_container input {
		width: 60px;
		text-align: right;
	}

	.time_container > input:nth-child(2),
	.time_total input {
		text-align: right;
	}

	.time_container > input:nth-child(4) {
		text-align: left;
	}

	input[type="text"] {
		border: none;
	}
</style>
